export default __webpack_public_path__ + "static/profile-picture-d7ec3abc1a1d20ffcd79765add4f7b88.webp";